import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { Icon: DefaultIconColor } = themeColorSectionKeys.defaults
const { ActiveCallBlock: CallBlockColors } = phoneColorKeys.Phone

const activeCallsBlockParts = ['header', 'text', 'iconButton', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(activeCallsBlockParts)

export const ActiveCallsBlockStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    header: {
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid',
      borderColor: CallBlockColors.CallBlockHeader.Border,
      paddingY: '4px',
      paddingX: '12px',
    },
    text: {},
    iconButton: {
      borderRadius: 'full',
      background:
        CallBlockColors.CallBlockHeader.NewCallButton.Background.Default,
      _hover: {
        background:
          CallBlockColors.CallBlockHeader.NewCallButton.Background.Hover,
        '& > svg': {
          color: CallBlockColors.CallBlockHeader.NewCallButton.Icon.Hover,
        },
      },
    },
    icon: {
      boxSize: '16px',
      color: DefaultIconColor,
    },
  },
  defaultProps: {},
})

export const useActiveCallsBlockStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ ActiveCallsBlockStyle }),
    props,
  ) as MultiStyleType<typeof activeCallsBlockParts>
}
